import { render, staticRenderFns } from "./Cuenta_x_Cobrar.vue?vue&type=template&id=293d8465"
import script from "./Cuenta_x_Cobrar.vue?vue&type=script&lang=js"
export * from "./Cuenta_x_Cobrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports